<div class="page-contents" id="quotes">

  <div class="subBlockContainer">

    <div class="breadcrumbWrapper">
      <app-breadcrumb></app-breadcrumb>
    </div>


    <div class="blockContainer narrow-sidebar subBlockContainer_toplevel" id="levelOne">

      <div class="combination-loader">

        <div class="child-sidebar sidebar-loader">
          <child-header [title]="title" (closeEvent)="navigateTo('/home')"></child-header>
          <!-- <div class="page-title-wrapper">
            <div class="title blade-title-font">
              {{title}}
            </div>
            <i class="material-icons closebutton-pullfloat-right" [routerLink]="['/home']">close</i>
          </div> -->
          <div class="child-body">
            <ng-container *ngFor="let item of MENULIST">
              <div class="menu-wrapper menu-font" [id]="item.menuRouter" [routerLink]="item.menuRouter"
                   routerLinkActive="active">
                {{item.menuName}}</div>
            </ng-container>
          </div>
          <!-- <div class="menu-wrapper" id="searchquotes">
            <div class="searchInputGroup">
              <div class="searchIcon">
                <img src="../images/new_ui/searchIcon-gray.png">
              </div>
              <ng-template #tipContent>
                <div>Type quotes number here.</div>
              </ng-template>
              <input class="searchInput" [ngbTooltip]="tipContent" placement="bottom" type="text"
                placeholder="Search Expired Quotes" onfocus="this.placeholder=''"
                onblur="this.placeholder='Search Expired Quotes'" [(ngModel)]="filterInput" (ngModelChange)="search(filterInput)">
            </div>
          </div> -->
          <div>
            <vertical-banner [bannerLocation]="'quote'"></vertical-banner>
          </div>
        </div>


        <div class="child-loader">
          <router-outlet></router-outlet>
        </div>


      </div>

    </div>

  </div>

</div>
